module.exports = __webpack_public_path__ + "img/portfolio-11-481x325.788d0dfc.jpg";